export default "__VITE_ASSET__CB1Y8Kjb__"